<div class="color-picker">
  <div class="summary-info" (click)="toggleColors()">
    <div class="info">
      <p class="style">{{ heading() }}</p>
      <p class="style-value">{{ currentColor() }}</p>
    </div>

    <div class="circle" [style.background]="currentColor()"></div>
  </div>

  @if (show) {
    <div class="opened">
      <div class="colors">
        @for (paint of defaultColors; track paint) {
          <div (click)="changeColor(paint)" class="circle"
          [style.background]="paint"></div>
        }
      </div>
      @if (hexcode()) {
        <div class="hex-code">
          <p>Hex Code</p>
          <div class="g-input">
            <input type="text" maxlength="7" [value]="currentColor()"
              (keyup)="changeColorManual(paintInput.value)"
              (keydown.enter)="toggleColors()"
              #paintInput/>
            </div>
          </div>
        }
      </div>
    }
  </div>
